import { Tag, useColor } from "@aircall/tractor";
import { isDefined } from "@dashboard/library";

import { getClosestColor } from "@/helpers/colors/colors.helpers";
import { useLuminance } from "@/hooks/useLuminance/useLuminance";

import { THRESHOLD, TagBeautifiedProps } from ".";

export function TagBeautified({
  color,
  children,
  size = "small",
  "data-test": dataTest = "tag-beautified",
}: TagBeautifiedProps) {
  const { textColor } = useLuminance({
    color,
    threshold: THRESHOLD,
  });

  const possibleTagColors = [
    useColor("secondary-800"),
    useColor("informative-500"),
    useColor("informative-600"),
    useColor("warning-500"),
    useColor("critical-300"),
    useColor("critical-500"),
    useColor("critical-700"),
    useColor("primary-300"),
    useColor("primary-600"),
    useColor("decorative1-300"),
    useColor("decorative2-700"),
    useColor("informative-100"),
  ].filter(isDefined) as string[];

  const { color: backgroundColor } = getClosestColor(color, possibleTagColors);

  return (
    <Tag
      data-test={dataTest}
      bg={backgroundColor}
      color={textColor}
      size={size}
    >
      {children}
    </Tag>
  );
}
